
import { Button } from "@/components/ui/button";
import { MessageSquare } from "lucide-react";

const Hero = () => {
  return (
    <section className="py-20 px-6 md:px-12 hero-gradient">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-3xl md:text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-seo-primary to-seo-secondary">
          Quer aparecer no Google quando alguém procura pelo seu serviço?
        </h1>
        <p className="text-xl md:text-2xl mb-8 text-gray-700">
          Atraia mais clientes da sua cidade com SEO Local. Deixe seu negócio visível no Google e no Google Maps.
        </p>
        <p className="mb-10 text-gray-600 max-w-2xl mx-auto">
          SEO Local é um conjunto de estratégias para fazer sua empresa aparecer nas buscas do Google por região, 
          como <span className="text-seo-accent font-medium">"eletricista em Belo Horizonte"</span>, <span className="text-seo-accent font-medium">"clínica odontológica em Campinas"</span>, etc. 
          Isso traz mais ligações, visitas e orçamentos para seu negócio.
        </p>
        <div className="flex justify-center">
          <Button 
            onClick={() => window.open('https://wa.me/5555115197440?text=Ol%C3%A1%2C%20quero%20uma%20analise%20da%20LocalUP.', '_blank')}
            className="bg-green-500 hover:bg-green-600 text-white px-8 py-6 text-lg rounded-lg shadow-lg flex items-center justify-center gap-2 transform transition-all duration-300 hover:-translate-y-1"
          >
            <MessageSquare className="w-5 h-5" /> Fale conosco no WhatsApp
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
